









































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Option} from '@/models';

import CrudOptionFilter from '@/components/Crud/Option/Filter.vue';
import CrudOptionEditDialog from '@/components/Crud/Option/EditDialog.vue';
import CrudOptionList from '@/components/Crud/Option/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeOption from '@/stores/modules/option';

@Component({
	components: {
		CrudOptionFilter,
		CrudOptionEditDialog,
		CrudOptionList,
		CrudDeleteDialog,
	}
})
export default class OptionView extends Vue {

	@Stored(() => storeOption)
	private Options!: ResultType<Option>;

	private editOption: Option = null;
	private deletedOption: Option = null;
	private storeOption = storeOption;
	private list;

	public mounted() {
		this.list = this.$refs['list'] as CrudOptionList
	}

	@Emit()
	private onCreate(): void {
		this.editOption = new Option();
	}

}
